(function () {
    'use strict';

    angular
        .module('eltazkaraApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requests', {
            parent: 'app',
            url: '/requests/:type',
            views: {
                'content@': {
                    templateUrl: 'components/requests/addRequest.html',
                    controller: 'RequestsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                checkRequestType: function($stateParams, $state) {
                    var type = $stateParams.type;
                    var types = ["Add_Event", "Add_Artist", "Add_Venue", "Contact_Us"];
                    if (types.indexOf(type) < 0) {
                        $state.go("app");
                    }
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();
